import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateVideo(nodeFields, accept) {
    const { idField, richAssetField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetVideo(richAssetField?.content))
        return;
    if (ast.isStringField(richAssetField.content.value)) {
        // Add a deprecation warning
        accept('warning', `String content for video is being deprecated. Please use the new JSON format.`, {
            node: richAssetField,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.nodeNumber,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
        const url = richAssetField.content.value.value.toLowerCase();
        if (!url || url.startsWith('https://') === false) {
            accept('error', `URL should point to a secure (https) location.`, {
                node: richAssetField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
    }
    else if (ast.isVideoJson(richAssetField.content.value)) {
        const videoJson = richAssetField.content.value;
        // Check for duplicate and required properties
        checkForDuplicateAndRequiredProperties({
            node: richAssetField,
            allProperties: videoJson.properties,
            requiredProperties: [ast.TypeStaticProperty, ast.UrlProperty],
            parentNode: nodeFields.refNode,
            accept,
        });
        // The url should start with https.
        const urlProperty = videoJson.properties.find((prop) => {
            return ast.isUrlProperty(prop);
        });
        const url = urlProperty?.url?.value?.toLowerCase();
        if (url && url.startsWith('https://') === false) {
            accept('error', `URL should point to a secure (https) location.`, {
                node: videoJson,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
    }
}
//# sourceMappingURL=video.js.map